import Utils from "../utils/utils";
import RequestManager from "./RequestManager";

const getUser = async (id) => {
    const userData = await RequestManager.get({
        url: "/user/v1" + (id ? "/" + id : "")
    });
    return userData;
};

const getAllUsersInDomain = async (
    domainId,
    size,
    firstCursor,
    lastCursor,
    prev,
    getLatest,
    filterUser,
    filterEnabled,
    targetId
) => {
    const urlParams = Utils.getUrlParams({
        size,
        prev,
        firstCursor,
        lastCursor,
        getLatest,
        extraQuery: {
            filterUser,
            filterEnabled,
            targetId
        }
    });

    const users = await RequestManager.get({
        url: "/user/domain/v1/" + domainId + urlParams
    });
    return users.data;
};

const getAllUsers = async (
    size,
    firstCursor,
    lastCursor,
    prev,
    getLatest,
    filterUser,
    filterEnabled,
    targetId
) => {
    const urlParams = Utils.getUrlParams({
        size,
        prev,
        firstCursor,
        lastCursor,
        getLatest,
        extraQuery: {
            filterUser,
            filterEnabled,
            targetId
        }
    });

    const users = await RequestManager.get({
        url: "/user/users/v1" + urlParams
    });
    return users.data;
};

const updateUser = async (id, body) => {
    const response = await RequestManager.put({
        url: "/user/v1/" + id,
        body
    });
    return response;
};

const verify = async (body) => {
    return RequestManager.post({
        url: "/user/verify/v1",
        body
    });
};

const resendVerification = async (id) => {
    return RequestManager.post({
        url: `/user/resendVerification/v1/${id}`
    });
};

const createUser = async (body) => {
    const response = await RequestManager.post({
        url: "/user/v1",
        body
    });
    return response;
};

const deleteUser = async (id) => {
    const response = await RequestManager.del({
        url: "/user/v1/" + id
    });
    return response;
};

const manualVerifyUser = async (id, body) => {
    const response = await RequestManager.post({
        url: `/user/manualVerify/v1/${id}`,
        body
    });
    return response;
};

const User = {
    getUser,
    getAllUsersInDomain,
    getAllUsers,
    updateUser,
    verify,
    resendVerification,
    createUser,
    deleteUser,
    manualVerifyUser
};

export default User;
